import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PrimaryButtonComponent } from '../../../../shared/components/primary-button/primary-button';
import { ImageEnum } from '../../../../shared/utils/image.enum';

@Component({
  selector: 'app-exam-recommendation-popup',
  imports: [PrimaryButtonComponent],
  templateUrl: './exam-recommendation-popup.html',
  styleUrl: './exam-recommendation-popup.css',
})
export class ExamRecommendationPopupComponent {
  @Input() isOpen = false;
  @Output() close = new EventEmitter<void>();
  @Output() enterFullScreen = new EventEmitter<void>();
  protected readonly imageEnum = ImageEnum

  protected onClose(): void {
    this.close.emit();
  }

  protected onEnterFullScreen(): void {
    this.enterFullScreen.emit();
  }
}
